<template>
  <div style="margin-top:30px">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="保险公司名称" prop="insureCompany">
        <el-input v-model="form.insureCompany" />
      </el-form-item>
      <el-form-item label="保险公司编码" prop="insureCompanyCode">
        <el-input v-model="form.insureCompanyCode" />
      </el-form-item>
      <el-form-item label="保单号" prop="policyNo">
        <el-input v-model="form.policyNo" />
      </el-form-item>
      <el-form-item label="保单 " required> 
        <ImgUpload
          :upload-config="{ lebal: '保单', prefix: 'policy', form: form, suffix: 'File',modal: false,}"
          :required="!form.filePath"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="funcSubmit('form')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import ImgUpload from "@/components/ImgUpload"
import request from '@/utils/request'
export default {
  components:{
    ImgUpload,
  },
  props:{
  },
  data(){
    return {
      dialogVisible:false,
      loading:false,
      tableData:[],
      emptyForm:{
        
      },
      form: {
        orderDetailCode:'',
        insureCompany:'',
        insureCompanyCode:'',
        policyNo:'',
        policyFile:'',
      },
      fit:'fill',
      rules: {
        insureCompany: [
          { required: true, message: "请输入保险公司名称", trigger: "blur" },
        ],
        insureCompanyCode: [
          {
            required: true,
            message: "请输入保险公司编码",
            trigger: "blur",
          },
        ],
         policyNo: [
          {
            required: true,
            message: "请输入保单号",
            trigger: "blur",
          },
        ],
      },
    }
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods:{
    // 获取页面信息
    getDatagram(code) {
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.form.orderDetailCode=code
      request({
        url: `/ntocc-basic-api/openInsure/readOfflinePolicy`,
        method: "get",
        params: {orderDetailCode:code}
      }).then((response) => {
        if(response.data ){
          this.form = response.data
          this.$set(this.form,'policyFile',this.form.filePath)
        }
        console.log(this.form)
      })
    },
     // 提交
    funcSubmit(form) {
      //console.log(this.form.smsCode);
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          request({
            url: '/ntocc-basic-api/openInsure/sendOfflinePolicy',
            method: 'get',
            params: data,
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            rLoading.close();
            this.$emit('onHideModeloffline')
          }).finally(() => {
              rLoading.close()
              this.$emit('onHideModeloffline')
            })
        } else {
          return false;
        }
      });
    },
    // 关闭
    funcCancel(){
		   this.$emit('onHideReport')
	  },
    showTime(val){
      // console.log(val);
    }
  }
};
</script>